import { fetcher } from "helpers/fetcher";

import { TGetCorpMemberFilterReq, TGetCorpMemberFilterRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getCorpMemberFilter = async (params?: TGetCorpMemberFilterReq) => {
  return await fetcher<TGetCorpMemberFilterRes, TGetCorpMemberFilterReq>(
    ENDPOINT.BU.GET_CORP_MEMBER_FILTER,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_CORP_MEMBER_FILTER.version,
        [API_HEADER.BU_ID]: params?.buId,
      },
    }
  );
};

export const queryGetCorpMemberFilter = async (
  params?: TGetCorpMemberFilterReq
) => {
  return (await getCorpMemberFilter(params)).data;
};

queryGetCorpMemberFilter._key = (params?: TGetCorpMemberFilterReq) => [
  ENDPOINT.BU.GET_CORP_MEMBER_FILTER.url,
  params,
];
